import React, {ReactNode} from "react";
import {BrowserRouter as Router, Routes, Route, Navigate, Outlet} from 'react-router-dom';
import LoginPageView from "../pages/login/LoginPageView.tsx";
import AsyncInits from "@/components/AsyncInits.tsx";
import HomePage from "@/pages/home/HomePage.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import CreditPage from "@/pages/credit/CreditPage.tsx";
import StandartCredit from "@/pages/standart_credit/StandartCredit.tsx";
import CreditLinePage from "@/pages/credit_line/CreditLinePage.tsx";
import CreditLineDetailsPage from "@/pages/credit_line_details/CreditLineDetailsPage.tsx";
import NewCredit from "@/pages/new_credit/NewCredit.tsx";
import ApplyCrLine from "@/pages/apply_cr_line/ApplyCrLine.tsx";
import {useAtom} from "jotai";
import {all_inits} from "@/atoms/common.ts";
import LoadingScreen from "@/ui/loadingScreen.tsx";
import Success from "@/pages/success_screens/Success.tsx";
import ApplyCreditForm from "@/pages/apply_credit/ApplyCreditForm.tsx";
import CrLinePage from "@/pages/cr_line_page/CrLinePage.tsx";
import EventListeners from "@/components/EventListeners.tsx";
import LocationsPage from "@/pages/locations/LocationsPage.tsx";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import CommonClass from "@/utils/common.ts";
import OfficePage from "@/pages/office/OfficePage.tsx";
import Banks from "@/pages/banks/Banks.tsx";
import BankPage from "@/pages/bank_page/BankPage.tsx";
import PendingLoans from "@/pages/pending_loans/PendingLoans.tsx";
import PMethods from "@/pages/payment_methods/PaymentMethods.tsx";
import AccountPage from "@/pages/account/Account.tsx";
import KYCPage from "@/pages/kyc/KYCPage.tsx";
import PromotionsPage from "@/pages/promotions/PromotionsPage.tsx";
import Promotion from "@/pages/promotions/Promotion.tsx";
import Page404 from "@/pages/page_404/Page404.tsx";
import SuccessKYC from "@/pages/success_screens/SuccessKYC.tsx";
import SuccessCr from "@/pages/success_screens/SuccessCr.tsx";
import KYCWaitingScreen from "@/pages/kyc/KYCWaitingScreen.tsx";
import NoConnection from "@/ui/NoConnection.tsx";
import SetPwdModal from "@/ui/modals/SetPwdModal.tsx";
import SetEmailModal from "@/ui/modals/SetEmailModal.tsx";
import SetPhoneModal from "@/ui/modals/SetPhoneModal.tsx";
import PromoPopup from "@/components/PromoPopup.tsx";
import AuthInits from "@/components/AuthInits.tsx";
import CreditInfoModal from "@/ui/modals/CreditInfoModal.tsx";
import LoginBackModal from "@/ui/modals/LoginBackModal.tsx";
import MobileCalculator from "@/components/calculator_components/MobileCalculator.tsx";
import NoClick from "@/ui/NoClick.tsx";
import SignContract from "@/pages/sign_contract/SignContract.tsx";
import AddNotifModal from "@/ui/modals/AddNotifModal.tsx";
import Notifications from "@/components/Notifications.tsx";
import BuildVersion from "@/ui/BuildVersion.tsx";
import PayCreditModal from "@/ui/modals/PayCreditModal.tsx";
import SuccessCrLine from "@/pages/success_screens/SuccessCrLine.tsx";
import CrLineTransaction from "@/pages/cr_line_transaction/CrLineTransaction.tsx";
import SignCrLineContract from "@/pages/sign_cr_line_contract/SignCrLineContract.tsx";
import SignTransactionContractOTP from "@/pages/success_screens/SuccessCrLineSign.tsx";
import UpdateHandler from "@/ui/UpdateHandler.tsx";
import DataConsentModal from "@/ui/modals/DataConsentModal.tsx";
import TestPage from "@/pages/test_page/test_page.tsx";
import GetContractModal from "@/ui/modals/GetContractModal.tsx";
import SuccessOpenCrLine from "@/pages/success_screens/SuccessOpenCrLine.tsx";
import BuildVersionListener from "@/components/BuildVersionListener.tsx";
import ResetPinPage from "@/pages/reset_pin/ResetPinPage.tsx";


interface Props{
    children:ReactNode
}

const GeneralComponent:React.FC<Props> = ({children}) => {
    const [is_init] = useAtom(all_inits)
    const recaptcha_settings = CommonClass.general_settings.recaptcha
    
    
    return (
        <>
            <NoConnection />
            <Notifications />
            <BuildVersion />
            <UpdateHandler />

            {(
                typeof recaptcha_settings?.public_key === "string" &&
                recaptcha_settings.public_key.length &&
                recaptcha_settings.is_enabled
            ) ? (
                <GoogleReCaptchaProvider
                    reCaptchaKey={recaptcha_settings.public_key}
                >
                    <AsyncInits />
                    <RouterPages />
                </GoogleReCaptchaProvider>
            ) : (

                <>
                    <AsyncInits />
                    <RouterPages />
                </>
            )}
            
            <LoadingScreen is_init={is_init} />
            
            {children}
        </>
    )
}


const RouterPages = () => {
    
    
    return (
        <Router>
            
            <EventListeners />
            <BuildVersionListener />
            {/*<BuildVersionModal />*/}
            
            <Routes>
                
                <Route element={<PublicRoute />}>
                    <Route path={DashboardClass.dashboard_routes.Login} element={<LoginPageView />} />
                    <Route path={DashboardClass.login_routes.ResetPin} element={<ResetPinPage />} />
                </Route>
                
                <Route element={<PrivateRoute />}>
                    
                    <Route path={DashboardClass.dashboard_routes.Home} element={<HomePage />} />
                    <Route path={DashboardClass.dashboard_routes.Credit + '/:urn'} element={<CreditPage />} />
                    <Route path={DashboardClass.dashboard_routes.StandartCredit} element={<StandartCredit />} />
                    <Route path={DashboardClass.dashboard_routes.CreditLine} element={<CreditLinePage />} />
                    <Route path={DashboardClass.dashboard_routes.CreditLine + '/:urn'} element={<CreditLineDetailsPage />} />
                    <Route path={DashboardClass.dashboard_routes.NewCredit} element={<NewCredit />} />
                    <Route path={DashboardClass.dashboard_routes.ApplyCrLine + "/:urn"} element={<ApplyCrLine />} />
                    <Route path={DashboardClass.dashboard_routes.Success} element={<Success />} />
                    <Route path={DashboardClass.dashboard_routes.SuccessOpenCrLine+"/:urn"} element={<SuccessOpenCrLine />} />
                    <Route path={DashboardClass.dashboard_routes.ApplyCredit} element={<ApplyCreditForm />} />
                    <Route path={DashboardClass.dashboard_routes.CrLineLoan + '/:contract'} element={<CrLinePage />} />
                    <Route path={DashboardClass.dashboard_routes.Locations} element={<LocationsPage />} />
                    <Route path={DashboardClass.dashboard_routes.Office + '/:location'} element={<OfficePage />} />
                    <Route path={DashboardClass.dashboard_routes.Banks + "/:urn/:all"} element={<Banks />} />
                    <Route path={DashboardClass.dashboard_routes.Banks} element={<Banks />} />
                    <Route path={DashboardClass.dashboard_routes.Bank + '/:bank'} element={<BankPage />} />
                    <Route path={DashboardClass.dashboard_routes.PendingLoans} element={<PendingLoans />} />
                    <Route path={DashboardClass.dashboard_routes.PaymentMethods} element={<PMethods />} />
                    <Route path={DashboardClass.dashboard_routes.Account} element={<AccountPage />} />
                    <Route path={DashboardClass.dashboard_routes.Promotions} element={<PromotionsPage />} />
                    {/*<Route path={"/promotions?offset=0&limit=${items_on_page}&page_number=1"} element={<PromotionsPage />} />*/}
                    <Route path={DashboardClass.dashboard_routes.Promo + "/:api_id"} element={<Promotion />} />
                    <Route path={DashboardClass.dashboard_routes.KYC + "/:step"} element={<KYCPage />} />
                    <Route path={DashboardClass.dashboard_routes.KYC} element={<Navigate to={`${DashboardClass.dashboard_routes.KYC}/1`} />} />
                    <Route path={DashboardClass.dashboard_routes.SuccessKYC} element={<SuccessKYC />} />
                    <Route path={DashboardClass.dashboard_routes.SuccessCr} element={<SuccessCr />} />
                    <Route path={DashboardClass.dashboard_routes.KYCWaitingRoom} element={<KYCWaitingScreen />} />
                    <Route path={DashboardClass.dashboard_routes.SignContract + "/:loan_urn"} element={<SignContract />} />
                    <Route path={DashboardClass.dashboard_routes.SignCrLineContract + "/:loan_urn"} element={<SignCrLineContract />} />
                    <Route path={DashboardClass.dashboard_routes.SuccessApplyCrLine + "/:urn"} element={<SuccessCrLine />} />
                    <Route path={DashboardClass.dashboard_routes.SuccessCrLineSign} element={<SignTransactionContractOTP />} />
                    <Route path={DashboardClass.dashboard_routes.CrLineTransaction + "/:urn"} element={<CrLineTransaction />} />
                    <Route path={"/test"} element={<TestPage />} />
                    
                </Route>
                
                <Route path="/" element={
                    CommonClass.init_auth ? (
                        <Navigate to={DashboardClass.dashboard_routes.Home} />
                    ) : (
                        <Navigate to={DashboardClass.dashboard_routes.Login} />
                    )
                } />
                
                <Route path="*" element={<Page404 />} />

            </Routes>
        </Router>
    );
};

const PrivateRoute = () => {
    return CommonClass.init_auth ? (
        <>
            <Outlet />
            <LoginBackModal />
            <NoClick />
            <AuthInits />
            <PromoPopup/>
            <SetPwdModal />
            <SetEmailModal />
            <SetPhoneModal />
            <CreditInfoModal />
            <MobileCalculator />
            <PayCreditModal />
            <DataConsentModal />
            <GetContractModal />
            {import.meta.env.MODE === 'development' && <AddNotifModal />}
        </>
    ) : (
        <Navigate to={DashboardClass.dashboard_routes.Login} />
    );
};

const PublicRoute = () => {
    if (CommonClass.init_auth) {
        const sw_pending = sessionStorage.getItem('sw_pending_redirect')
        if (sw_pending) {
            sessionStorage.removeItem('sw_pending_redirect')
            return <Navigate to={sw_pending} />
        }
        return <Navigate to={DashboardClass.dashboard_routes.Home} />;
    }
    return <Outlet />;
};


export default GeneralComponent